/**
 * TTL string formatını milisaniyeye çevirir
 * @param {string|number} ttl - TTL değeri (örn: "5m", "2h", 60000)
 * @returns {number} Milisaniye cinsinden TTL değeri
 */
export const parseTTL = (ttl) => {
  // Eğer sayı veya null/undefined ise doğrudan döndür
  if (ttl === null || ttl === undefined) {
    return null
  }

  if (typeof ttl === 'number') {
    return ttl
  }

  // String değilse hata ver
  if (typeof ttl !== 'string') {
    throw new Error(`Geçersiz TTL formatı: ${ttl}. String veya number olmalı.`)
  }

  // Boş string kontrolü
  if (ttl.trim() === '') {
    return null
  }

  // String formatını parse et
  const regex = /^(\d+)([smhdw])$/
  const match = ttl.match(regex)

  if (!match) {
    throw new Error(`Geçersiz TTL formatı: ${ttl}. Örnek: "30s", "5m", "2h", "1d", "1w".`)
  }

  const value = parseInt(match[1], 10)
  const unit = match[2]

  // Birim çarpanları (milisaniye cinsinden)
  const multipliers = {
    s: 1000,           // saniye
    m: 60 * 1000,      // dakika
    h: 60 * 60 * 1000, // saat
    d: 24 * 60 * 60 * 1000, // gün
    w: 7 * 24 * 60 * 60 * 1000, // hafta
  }

  return value * multipliers[unit]
}